import { CertificateNavigator } from '@certificate/certificate-navigator';
import { useParams } from '@certificate/router';

/**
 * @deprecated
 * Use ExamEventExamineePage instead
 * This page will only be used for the certificate of first exam on Aug 24th 2025
 */
export default function HomePage() {
  const { certificateId } = useParams('/certificates/:certificateId');

  return <CertificateNavigator certificateId={certificateId} />;
}
